
import _ from 'lodash';
import { createResponse } from '../altFunctions/common';
import { createResponseTypes } from '../cnr/reducers/CreateReducer';

const regGenericTypes = {
  regGeneric: 'regGeneric',
}

const regFunctionTypes = {
  createEventFromFetch: 'createEventFromFetch',
  getRegData: 'getRegData',
};
/**
 * 
 * @param {object} callData 
 * @returns - The `data` object {success,result, error}
 */
const callFsFunction = async (fsCall, callData) => {
  const data = await fsCall(regGenericTypes.regGeneric, callData)
  return data
}

// 67BC9D2B644B6
export const fsfn_allReg = (fsCall) => {
  return {
    createEventFromFetch: (urlData) => fsfn_createEventFromFetch(fsCall, urlData),
    getRegData: (clientKey, eventKey, createEvent, showToken) => fsfn_getRegData(fsCall, clientKey, eventKey, createEvent, showToken),
  }
}

// https://nfpa.events.meetingevolution.net/index.php?option=com_chronoforms&tmpl=component&chronoform=attendeeregistration_event_preview_mobile_app&eventId=6807EE5CB0DAC
// https://nfpa.events.meetingevolution.net/index.php?option=com_chronoforms&tmpl=component&chronoform=attendeeregistration_event_preview_mobile_app&eventId=6807EE5CB0DAC

const fsfn_getRegData = async (fsCall, clientKey, eventKey, createEvent, showToken) => {
  // 68800D191853D
  // 687FE76F63778
  //   Creator Cup at Emirates NBA Cup 2025 - Fri Dec 12, 2025 - 68E57DC8B9C19 
  // NBA Tourism Showcase London 2026 - Fri Jan 16, 2026 - 691B8AD2ED3EA 
  // WNBA Investor Day 2025 - Thu Dec 04, 2025 - 68FA5290386CE 
  // Global Experience Program Fall 2025 - Mon Nov 17, 2025 - 68F11C38CF593
  const callData = {
    clientKey,
    eventKey,
    fetchFunctionType: regFunctionTypes.getRegData,
    showToken,
    createEvent,
    showLogs: true,
    ignores: ['reservations'],
    //9BEC61EC5746BFD85CE5
    // cHJvYkgNpMx8Lov7nq5UC2xEOvitdNEmOgaId6aaSStuvNrVf7lKhPiEe9fO7g53
  }
  try {
    const response_data = await callFsFunction(fsCall, callData) // OK   
    console.log('fsfn_getRegData', response_data)
    // DEMO
    return response_data
  } catch (error) {
    console.error('fsfn_getRegData - error', error)
    return createResponse(false, 'Not Successfull', createResponseTypes.catchError, error)
  }
  // responseFn && responseFn(response_data)
}

const fsfn_createEventFromFetch = async (fsCall, urlData) => {
  // console.log('response', response)
  // urlData.options = {
  //   "menthod": "GET",
  //   "rejectUnauthorized": false,
  //   "credentials": "include",
  //   headers: { "Content-Type": "application/json" }
  // }   
  urlData.ignoreSLL = true
  const callData = {
    urlData,
    fetchFunctionType: regFunctionTypes.createEventFromFetch
  }
  try {
    const response_data = await callFsFunction(fsCall, callData) // OK
    return response_data
  } catch (error) {
    console.error('fsfn_createEventFromFetch - error', error)
    return createResponse(false, 'Not Successfull', createResponseTypes.catchError, error)
  }
  // responseFn && responseFn(response_data)
}

